/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonCheckSecretDto } from '../../models/dbr-balloon-check-secret-dto';
import { DbrSuccessResponseDto } from '../../models/dbr-success-response-dto';

export interface BalloonsControllerCheckSecret$Params {
      body: DbrBalloonCheckSecretDto
}

export function balloonsControllerCheckSecret(http: HttpClient, rootUrl: string, params: BalloonsControllerCheckSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrSuccessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerCheckSecret.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrSuccessResponseDto>;
    })
  );
}

balloonsControllerCheckSecret.PATH = '/balloons/secret';
